import React, { useState, useEffect } from 'react';

function ZoomSettings() {
  const [connected, setConnected] = useState(false);
  const [zoomInfo, setZoomInfo] = useState(null);

  const connectZoom = () => {
    // Redirect to backend endpoint to initiate Zoom OAuth.
    // Pass the counsellor's ID (here 1 for example)
    window.location.href = 'https://api.psychooncology.online/api/zoom/connect?counselorId=1';
  };

  useEffect(() => {
    // Optionally, after successful connection, call an API to check connection status.
    // For simplicity, we assume that if there's token info, then the account is connected.
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h2>Zoom Account Settings</h2>
      {connected ? (
        <div>
          <p>Your Zoom account is connected.</p>
          <pre>{JSON.stringify(zoomInfo, null, 2)}</pre>
        </div>
      ) : (
        <button onClick={connectZoom} style={{ padding: '10px 20px', fontSize: '16px' }}>
          Connect Zoom Account
        </button>
      )}
    </div>
  );
}

export default ZoomSettings;
